import qs from 'qs';
import { call, takeLatest } from 'redux-saga/effects';
import { navigate } from 'next/lib/history';
import { isSpoofing, spoof, despoof } from 'next/lib/auth';
import { setSpoof } from 'next/lib/crx';
import { INITIALIZE } from 'next/root/actions';
import { SPOOF_STARTED, SPOOF_STOPPED } from './actions';

/**
 * TODO: Add toast notifications on success/failure
 */

const KEY = 'view_as';

const scrape = param => {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const { [param]: value, ...rest } = query;

  if (!value) {
    return null;
  }

  window.history.replaceState(null, '', `?${qs.stringify(rest)}`);

  return value;
};

function* startSpoof({ payload: id }) {
  try {
    yield call(spoof, id);
    yield call(navigate, '/');
  } catch {
    // TODO: Handle error properly
  }
}

function* stopSpoof() {
  try {
    yield call(despoof);
    yield call(navigate, '/');
  } catch {
    // TODO: Handle error properly
  }
}

function* initialize({ payload: auth }) {
  try {
    const { accountId } = auth;

    const param = yield call(scrape, KEY);
    const spoofing = yield call(isSpoofing);

    if (param) {
      if (spoofing) {
        yield call(despoof);
      }

      yield call(spoof, param);
      yield call(navigate, '/');
    } else {
      yield call(setSpoof, { accountId, spoofing });
    }
  } catch {
    // TODO: Handle error
  }
}

export default function* saga() {
  yield takeLatest(SPOOF_STARTED, startSpoof);
  yield takeLatest(SPOOF_STOPPED, stopSpoof);
  yield takeLatest(INITIALIZE, initialize);
}
